@for (chart of stackedBarLineData; track $index) {
<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="flex-grow-1">
          <h4 class="fs-20 fs-lg-24 mb-3">
            {{this._translate.currentLang == "en" ? chart.titleEn: chart.titleAr}}
            <!-- Disclaimer tooltip -->
            <span ngbTooltip="{{_translate.currentLang == 'en' ? chart.descriptionEn: chart.descriptionAr}}"
              placement="right">
              <img src="/assets/images/svg/icon-info.svg" alt="" class="wh-20">
            </span>
          </h4>
        </div>
        <div>
          <canvas baseChart height="300" [datasets]="cashPositioning.datasets" [labels]="cashPositioning.labels"
            [options]="barLineChartOptions" [type]="'line'">
          </canvas>
        </div>
      </div>
    </div>
  </div>
</div>
}
<!-- <div class="row" *ngFor="let chart of stackedBarLineData">
<div class="col-lg-12">
  <div class="card">
    <div class="card-body">
      <div class="flex-grow-1">
        <h4 class="fs-20 fs-lg-24 mb-3">
          {{this._translate.currentLang == "en" ? chart.titleEn: chart.titleAr}}
          <span ngbTooltip="{{_translate.currentLang == 'en' ? chart.descriptionEn: chart.descriptionAr}}" placement="right">
            <img src="/assets/images/svg/icon-info.svg" alt="" class="wh-20">
          </span>
        </h4>
      </div>
      <div>
        <div id="chart">
          <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart"
            [yaxis]="chartOptions.yaxis" [xaxis]="chartOptions.xaxis" [labels]="cashPositioning.labels"
            [markers]="chartOptions.markers" [stroke]="chartOptions.stroke" [title]="chartOptions.title"
          [fill]="chartOptions.fill" [tooltip]="chartOptions.tooltip"></apx-chart>
        </div>
      </div>
    </div>
  </div>
</div>
</div> -->